<template>
  <div class="result-section-container">
    <div class="card-header" v-if="!props.isLoading">
      Lesson Packages Result {{ index + 1 }}
    </div>
    <div class="card">
      <div v-if="props.isLoading">
        <LoadingComponent v-if="props.isLoading"></LoadingComponent>
      </div>
      <div v-else class="card-content">
        <div class="card-info">
          <h2>{{ props.result?.topic }}</h2>
          <p>{{ props.result?.summary }}</p>
        </div>
        <div class="result-tags">
          <div v-for="tag in props.result?.tags" :key="tag" class="result-tag">
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <ActionButton
        variant="primary"
        v-if="!props.isLoading"
        @click="goToPreview(props.idGenerated, index + 1)"
      >
        Build Lesson Package
      </ActionButton>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { useRouter } from "vue-router";
import LoadingComponent from "@/components/LoadingComponent.vue";
import cookiesService from "@/services/cookiesService";
import { useStore } from "vuex";
import LocalStorageService from "@/services/localStorageService";
import ActionButton from "./common/ActionButton.vue";

// eslint-disable-next-line
const router = useRouter();
const store = useStore();

const props = defineProps({
  result: Object,
  index: Number,
  idGenerated: Number,
  isLoading: Boolean,
});

const goToPreview = ref(async (idGenerated, index) => {
  const authToken = await cookiesService.getCookie("authToken");
  if (authToken) {
    let redirectObject = {
      resource_id: idGenerated,
      option: index,
    };

    let jsonString = JSON.stringify(redirectObject);

    let encryptedString = encodeURIComponent(jsonString);

    router.push("/preview?data=" + encryptedString);
  } else {
    let redirectObject = {
      resource_id: idGenerated,
      option: index,
    };
    store.commit("SET_SELECTED_LESSON_PACKAGE", redirectObject);
    const storedData = store.state;
    LocalStorageService.setCacheWithExpiry("cache-generate", storedData);
    window.location = `${process.env.VUE_APP_LOGIN_URL}/request-login`;
  }
});
</script>

<style scoped>
.result-section-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.card-header {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  color: #003d6a;
}

.card {
  background-color: #ffffff;
  border: 1px solid #d8dae5;
  border-radius: 16px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-info h2 {
  font-family: "League Spartan", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #003d6a;
  margin: 0;
}

.card-info p {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3b4648;
  margin: 0;
}

.result-tags {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.result-tag {
  background-color: #ffffff;
  border: 1px solid #dfe2e7;
  border-radius: 4px;
  padding: 8px 12px;
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #40444b;
  text-align: center;
}

.card-footer {
  text-align: right;
}

.button {
  border: none;
  cursor: pointer;
  border-radius: 25px;
  text-decoration: none;
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  background-color: var(--primary-blue);
  color: white;
  padding: 10px 20px;
}

.button:hover {
  background-color: #002744;
}

@media (max-width: 768px) {
  .result-section-container {
    gap: 12px;
    padding: 0px;
  }

  .card-header {
    font-size: 24px;
    line-height: 32px;
  }

  .card {
    padding: 16px;
    border-radius: 12px;
  }

  .card-content {
    gap: 16px;
  }

  .card-info {
    gap: 12px;
  }

  .card-info h2 {
    font-size: 18px;
  }

  .card-info p {
    font-size: 14px;
    line-height: 20px;
  }

  .button {
    width: 100%;
    margin-top: 8px;
    padding: 12px 20px;
    border-radius: 12px;
  }

  .card-footer {
    text-align: center;
  }

  .card-footer :deep(.action-button) {
    width: 100%;
    font-size: var(--fs-small);
  }

  .card-footer :deep(.action-button__text) {
    font-size: var(--fs-small);
  }
}
</style>
